import { Box, Grid, MenuItem, TextField, Typography } from "@mui/material";
import {
    getWordCloudAppearance,
    WORD_CLOUD_ORIENTATIONS,
    WORD_CLOUD_PALETTES,
} from "utils/wordCloudAppearance";

const WordCloudAppearanceControls = ({ configuration, onChange, disabled }) => {
    const appearance = getWordCloudAppearance(configuration);
    const palette = WORD_CLOUD_PALETTES.find((item) => item.value === appearance.colorPalette);
    const fontSize = (value) => Math.min(200, Math.max(1, Math.round(Number(value) || 1)));

    return (
        <Grid item xs={12}>
            <h3>Personalizar gráfico</h3>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        select fullWidth label="Paleta de colores"
                        value={appearance.colorPalette} disabled={disabled}
                        onChange={(event) => onChange({ colorPalette: event.target.value })}
                    >
                        {WORD_CLOUD_PALETTES.map((item) => (
                            <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                        ))}
                    </TextField>
                    <Box display="flex" gap={0.5} mt={1} aria-label={`Colores de la paleta ${palette.label}`}>
                        {palette.colors.map((color) => (
                            <Box key={color} sx={{ backgroundColor: color, width: 20, height: 12, borderRadius: 0.5 }} />
                        ))}
                    </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        select fullWidth label="Orientación de las palabras"
                        value={appearance.orientation} disabled={disabled}
                        onChange={(event) => onChange({ orientation: event.target.value })}
                    >
                        {WORD_CLOUD_ORIENTATIONS.map((item) => (
                            <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth type="number" label="Tamaño mínimo de las palabras"
                        inputProps={{ min: 1, max: 200 }} value={appearance.minFontSize} disabled={disabled}
                        onChange={(event) => {
                            const value = fontSize(event.target.value);
                            onChange({ minFontSize: value, maxFontSize: Math.max(value, appearance.maxFontSize) });
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth type="number" label="Tamaño máximo de las palabras"
                        inputProps={{ min: 1, max: 200 }} value={appearance.maxFontSize} disabled={disabled}
                        onChange={(event) => {
                            const value = fontSize(event.target.value);
                            onChange({ maxFontSize: value, minFontSize: Math.min(value, appearance.minFontSize) });
                        }}
                    />
                </Grid>
            </Grid>
            <Typography variant="caption" color="text.secondary" component="p">
                La nube ajusta los tamaños al espacio disponible. Podés cambiar su apariencia después de graficar,
                antes de agregarla a la entrega.
            </Typography>
        </Grid>
    );
};

export default WordCloudAppearanceControls;
